import { lazy } from "react"
import { Navigate } from "react-router-dom"

import NotFound from "@/views/not-found"
const Home = lazy(() => import('@/views/home'))
const Detail = lazy(() => import('@/views/detail'))
const Entire = lazy(() => import('@/views/entire'))
const Test = lazy(() => import('@/views/test'))

const routes = [
  { path: '/', element: <Navigate to='/home'/> },
  { path: '/home', element: <Home /> },
  { path: '/entire', element: <Entire /> },
  { path: '/detail', element: <Detail /> },
  { path: '/test', element: <Test /> },
  { path: '*', element: <NotFound /> }
]
console.log('routes', routes)

export default routes